import { useEffect } from "react";
import { LandingPage } from "./landingPage/Index";
import { Goals } from "./goals/Index";
import { Problems } from "./problems/Index";
import { Values } from "./values/Index";
import { Features } from "./features/Index";
import { Results } from "./results/Index";
import { Creators } from "./creators/Index";
import { Support } from "./support/Index";
import { Footer } from "./footer/Index";
import { TalkWhatsApp } from "../../components/LandingPage/TalkWhatsApp/Index";
import "./styles.css";

export function HomePageV2() {
  useEffect(() => {
    document.title = "Pastejo";
  }, []);

  return (
    <div className="home-page-v2">
      <LandingPage />
      <Goals />
      <Problems />
      <Values />
      <Features />
      <Results />
      <Creators />
      <Support />
      <Footer />

      <TalkWhatsApp />
    </div>
  );
}
